/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Runtime flush mode handling
 * @legacy
 * @alpha
 */
export var FlushMode;
(function (FlushMode) {
    /**
     * In Immediate flush mode the runtime will immediately send all operations to the driver layer.
     *
     * @deprecated This option will be removed in the next major version and should not be used. Use {@link FlushMode.TurnBased} instead, which is the default.
     * See https://github.com/microsoft/FluidFramework/tree/main/packages/runtime/container-runtime/src/opLifecycle#how-batching-works
     */
    FlushMode[FlushMode["Immediate"] = 0] = "Immediate";
    /**
     * When in TurnBased flush mode the runtime will buffer operations in the current turn and send them as a single
     * batch at the end of the turn. The flush call on the runtime can be used to force send the current batch.
     */
    FlushMode[FlushMode["TurnBased"] = 1] = "TurnBased";
})(FlushMode || (FlushMode = {}));
/**
 * @internal
 */
export var FlushModeExperimental;
(function (FlushModeExperimental) {
    /**
     * When in Async flush mode, the runtime will accumulate all operations across JS turns and send them as a single
     * batch when all micro-tasks are complete.
     *
     * This feature requires a version of the loader which supports reference sequence numbers. If an older version of
     * the loader is used, the runtime will fall back on FlushMode.TurnBased.
     *
     * @experimental - Not ready for use
     */
    FlushModeExperimental[FlushModeExperimental["Async"] = 2] = "Async";
})(FlushModeExperimental || (FlushModeExperimental = {}));
/**
 * This tells the visibility state of a Fluid object. It basically tracks whether the object is not visible, visible
 * locally within the container only or visible globally to all clients.
 * @legacy
 * @alpha
 */
export const VisibilityState = {
    /**
     * Indicates that the object is not visible. This is the state when an object is first created.
     */
    NotVisible: "NotVisible",
    /**
     * Indicates that the object is visible locally within the container. This is the state when an object is attached
     * to the container's graph but the container itself isn't globally visible. The object's state goes from not
     * visible to locally visible.
     */
    LocallyVisible: "LocallyVisible",
    /**
     * Indicates that the object is visible globally to all clients. This is the state of an object in 2 scenarios:
     *
     * 1. It is attached to the container's graph when the container is globally visible. The object's state goes from
     * not visible to globally visible.
     *
     * 2. When a container becomes globally visible, all locally visible objects go from locally visible to globally
     * visible.
     */
    GloballyVisible: "GloballyVisible",
};
//# sourceMappingURL=dataStoreContext.js.map